import {addHours, differenceInMilliseconds} from 'date-fns';

import {useRef} from 'react';

import {parseDate, useOnMount} from 'shared/web';

import {FINANCING_ENDING_DELIVERY_RESULT_DEADLINE_HOURS} from '../../constants/FINANCING_ENDING_DELIVERY_RESULT_DEADLINE_HOURS';

export type FinancingEndingDeliveryDeadlineTimerProps = {
  finishedAt: string;
  onDeadlinePassed: () => void;
};

/**
 * Calls `onDeadlinePassed` once the delivery result deadline after `finishedAt` has passed, or at
 * once when it passed already. Mount it with `finishedAt` as the key to restart it for a new value.
 */
export function FinancingEndingDeliveryDeadlineTimer(
  props: FinancingEndingDeliveryDeadlineTimerProps
) {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useOnMount(
    () => {
      const deadline = addHours(
        parseDate(props.finishedAt),
        FINANCING_ENDING_DELIVERY_RESULT_DEADLINE_HOURS
      );
      timeoutRef.current = setTimeout(
        props.onDeadlinePassed,
        Math.max(0, differenceInMilliseconds(deadline, new Date()))
      );
    },
    () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
    }
  );

  return null;
}
